var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"error-403"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('errors.403-forbidden-title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('errors.403-forbidden-message')))]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t('errors.goHome-link')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }